export interface DetectedRegion {
	countryCode: string;
	countryName: string;
	region: string;
	city: string;
	ip: string;
}

/** IpApiResponse example:
{
    "ip": "90.190.187.189",
    "network": "90.190.184.0/21",
    "version": "IPv4",
    "city": "Pärnu",
    "region": "Pärnumaa",
    "region_code": "68",
    "country": "EE",
    "country_name": "Estonia",
    "country_code": "EE",
    "country_code_iso3": "EST",
    "country_capital": "Tallinn",
    "country_tld": ".ee",
    "continent_code": "EU",
    "in_eu": true,
    "postal": null,
    "latitude": 58.3891,
    "longitude": 24.4983,
    "timezone": "Europe/Tallinn",
    "utc_offset": "+0300",
    "country_calling_code": "+372",
    "currency": "EUR",
    "currency_name": "Euro",
    "languages": "et,ru",
    "country_area": 45226.0,
    "country_population": 1320884,
    "asn": "AS3249",
    "org": "Telia Eesti AS"
}
*/
export interface IpApiResponse {
	ip: string;
	city: string;
	region: string;
	country: string;
	country_name: string;
	country_code: string;
	continent: string;
	continent_code: string;
	timezone: string;
	latitude: number;
	longitude: number;
}

export const detectUserRegion = async (): Promise<DetectedRegion | null> => {
	try {
		if (process.env.NODE_ENV !== 'production') {
			return {
				countryCode: 'EE',
				countryName: 'Estonia',
				region: 'Europe',
				city: 'Pärnu',
				ip: '127.0.0.1',
			};
		}
		const response = await fetch('https://ipapi.co/json/', {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
			},
		});

		if (!response.ok) {
			console.warn('IP detection failed:', response.status);
			return null;
		}

		const data: IpApiResponse = await response.json();
		
		// Map the response to our DetectedRegion interface
		return {
			countryCode: data.country_code,
			countryName: data.country_name,
			region: data.continent_code, // Using continent as region
			city: data.city || 'Unknown',
			ip: data.ip,
		};
	} catch (error) {
		console.warn('IP detection error:', error);
		return null;
	}
}; 